import { v4 as uuidv4 } from 'uuid';

export default [
    {
        idSoft: uuidv4(),
        name: '_4x6_',
        text: "10x15cm - 1950x1300 px",
        width: 1950,
        height: 1300,
        widthCM: 15,
        heightCM: 10,
        ratio: 1.5,
    },
    {
        idSoft: uuidv4(),
        name: '_6x8_',
        text: "15x20cm - 2600x1950 px",
        width: 2600,
        height: 1950,
        widthCM: 20,
        heightCM: 15,
        ratio: 1.33,
    },
]
